import { Component, input, viewChild } from '@angular/core';
import { IColumn } from '@app/shared/interfaces/column.interface';
import { IFiltredDashboardResponse } from '@app/shared/interfaces/dashboard.interface';
import { TableComponent } from '@app/shared/components/table-component/table.component';
import { ExcelButtonComponent } from '@app/shared/components/excel-button/excel-button.component';
import { CardComponent } from '@app/shared/components/card/card.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-agent-reservation-cancel-change',
    imports: [CommonModule, TableComponent, ExcelButtonComponent, CardComponent],
    templateUrl: './agent-reservation-cancel-change.component.html',
    styleUrl: './agent-reservation-cancel-change.component.scss'
})
export class AgentReservationCancelChangeComponent {
    agentCellTemplate = viewChild('agentCellTemplate');
    cancelBadgeTemplate = viewChild('cancelBadgeTemplate');
    changeBadgeTemplate = viewChild('changeBadgeTemplate');

    loading = input<boolean>(false);
    agentBiStatisticData = input<IFiltredDashboardResponse['agentBiStatistic']['results']>();

    cols: IColumn[] = [];

    ngOnInit() {
        this.cols = [
            { key: 'agentName', label: 'Agent', template: this.agentCellTemplate(), sortable: true },
            { key: 'reservationCancel', label: 'Cancellations', template: this.cancelBadgeTemplate(), sortable: true },
            { key: 'voluntaryFlightCancel', label: 'Changes', template: this.changeBadgeTemplate(), sortable: true }
        ];
    }

    getInitials(name: string): string {
        if (!name) return 'AG';
        return name.replace(/[^A-Z ]/g, '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('') || 'AG';
    }

    exportData(): any[] {
        return (
            this.agentBiStatisticData()?.map((item) => ({
                reservationCancel: item.reservationCancel ?? '',
                agentName: item.agentName ?? '',
                voluntaryFlightCancel: item.voluntaryFlightCancel ?? ''
            })) ?? []
        );
    }
}
